import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
const CardErrorMessage = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    "data-test-id": "card-error-message",
    title: /*#__PURE__*/_jsx(H7, {
      marginBlock: "0",
      paddingBlock: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmCards.errors.loading.description"
      })
    }),
    illustrationProps: {
      maxBlockSize: '120px',
      maxInlineSize: '36%',
      marginBlockEnd: '400'
    },
    marginBlockStart: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmCards.errors.loading.ctaWithoutRetryDescription"
    })
  });
};
export default CardErrorMessage;